import { useEffect } from 'react';

const getOrCreateFaviconLink = (): HTMLLinkElement => {
  const existingLink = document.head.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  if (existingLink) return existingLink;

  const faviconLink = document.createElement('link');
  document.head.append(faviconLink);
  return faviconLink;
};

const setFavicon = (href: string): void => {
  const faviconLink = getOrCreateFaviconLink();
  faviconLink.rel = 'icon';
  faviconLink.type = 'image/png';
  faviconLink.setAttribute('href', href);
};

export const useFavicon = (
  faviconHref: string,
  fallbackFaviconHref: string,
): void => {
  useEffect(() => {
    setFavicon(faviconHref);
    return () => setFavicon(fallbackFaviconHref);
  }, [faviconHref, fallbackFaviconHref]);
};
